function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import orderBy from 'lodash.orderby';
import some from 'lodash.some';
import isEqual from 'lodash.isequal';
import Paginator from "./Paginator";
import SortableTable from "./SortableTable";

var UncontrolledTable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UncontrolledTable, _React$Component);

  var _super = _createSuper(UncontrolledTable);

  function UncontrolledTable() {
    var _this;

    _classCallCheck(this, UncontrolledTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      sort: _this.props.sort,
      expanded: _this.props.expanded,
      selected: _this.props.selected,
      page: _this.props.page
    };

    _this.sortedData = function (rows, column, ascending) {
      return orderBy(rows, [column], [ascending ? 'asc' : 'desc']);
    };

    _this.sortBy = function (column, ascending) {
      var sort;

      if (_this.state.sort.column === column) {
        sort = {
          column: column,
          ascending: ascending
        };
      } else {
        sort = {
          column: column,
          ascending: true
        };
      }

      _this.setState({
        sort: sort
      }, function () {
        return _this.props.onSort(sort);
      });
    };

    _this.toggleSelection = function (value) {
      var selected = _this.state.selected;
      var newSelection = some(selected, value) ? selected.filter(function (selectedRow) {
        return !isEqual(selectedRow, value);
      }) : [].concat(_toConsumableArray(selected), [value]);

      _this.setState({
        selected: newSelection
      }, function () {
        _this.props.onSelect(newSelection);
      });
    };

    _this.toggleAll = function () {
      var newSelection = _this.allSelected ? [] : _this.props.rows;

      _this.setState({
        selected: newSelection
      }, function () {
        _this.props.onSelect(newSelection);
      });
    };

    _this.toggleExpanded = function (value) {
      var expanded = _this.state.expanded;
      var newExpanded = some(expanded, value) ? expanded.filter(function (expandedRow) {
        return !isEqual(expandedRow, value);
      }) : [].concat(_toConsumableArray(expanded), [value]);

      _this.setState({
        expanded: newExpanded
      }, function () {
        return _this.props.onExpand(newExpanded);
      });
    };

    _this.setPage = function (page) {
      _this.setState({
        page: page
      });

      _this.props.onPageChange(page);
    };

    _this.isEqualUsingKeys = function (newArray, oldArray) {
      var hasKey = function hasKey(element) {
        return element.key !== undefined;
      };

      if (!(newArray.every(hasKey) && oldArray.every(hasKey))) {
        return newArray === oldArray;
      }

      var keys = oldArray.map(function (el) {
        return el.key;
      }).sort();
      var newKeys = newArray.map(function (el) {
        return el.key;
      }).sort();
      return isEqual(keys, newKeys);
    };

    return _this;
  }

  _createClass(UncontrolledTable, [{
    key: "selected",
    value: function selected(value) {
      return some(this.state.selected, value);
    }
  }, {
    key: "expanded",
    value: function expanded(value) {
      return some(this.state.expanded, value);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    //eslint-disable-next-line camelcase
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var selectableChanged = nextProps.selectable !== this.props.selectable;
      var expandableChanged = nextProps.expandable !== this.props.expandable;
      var expandedChanged = !this.isEqualUsingKeys(this.props.expanded, nextProps.expanded);
      var selectedChanged = !this.isEqualUsingKeys(this.props.selected, nextProps.selected);
      var rowsChanged = !this.isEqualUsingKeys(this.props.rows, nextProps.rows); // Clear selection if rows or selectable change

      if (rowsChanged || selectableChanged) {
        this.setState({
          selected: []
        });
      }

      if (rowsChanged || expandableChanged) {
        this.setState({
          expanded: []
        });
      }

      if (rowsChanged) {
        this.setState({
          page: 0
        });
      }

      if (selectedChanged) {
        this.setState({
          selected: nextProps.selected
        });
      }

      if (expandedChanged) {
        this.setState({
          expanded: nextProps.expanded
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var page = this.state.page;
      var _this$state$sort = this.state.sort,
          ascending = _this$state$sort.ascending,
          column = _this$state$sort.column;

      var _this$props = this.props,
          columns = _this$props.columns,
          expandable = _this$props.expandable,
          pageSize = _this$props.pageSize,
          paginated = _this$props.paginated,
          _rowExpanded = _this$props.rowExpanded,
          rows = _this$props.rows,
          selectable = _this$props.selectable,
          sort = _this$props.sort,
          onSelect = _this$props.onSelect,
          onExpand = _this$props.onExpand,
          onSort = _this$props.onSort,
          onPageChange = _this$props.onPageChange,
          props = _objectWithoutProperties(_this$props, ["columns", "expandable", "pageSize", "paginated", "rowExpanded", "rows", "selectable", "sort", "onSelect", "onExpand", "onSort", "onPageChange"]);

      var cols = columns.filter(function (col) {
        return !col.hidden;
      }).map(function (col) {
        return col.sortable !== false ? _objectSpread({
          active: column === col.key,
          ascending: ascending,
          onSort: function onSort(asc) {
            return _this2.sortBy(col.key, asc);
          }
        }, col) : col;
      });
      var selectableProps = selectable ? {
        rowSelected: function rowSelected(row) {
          return _this2.selected(row);
        },
        onSelect: function onSelect(row) {
          return _this2.toggleSelection(row);
        },
        onSelectAll: function onSelectAll() {
          return _this2.toggleAll();
        },
        allSelected: this.allSelected
      } : undefined;
      var expandableProps = expandable ? {
        rowExpanded: function rowExpanded(row) {
          return _this2.expanded(row) && _rowExpanded(row);
        },
        onExpand: function onExpand(row) {
          return _this2.toggleExpanded(row);
        }
      } : undefined;
      var start = page * pageSize;
      var end = start + pageSize;
      var sortedRows = this.sortedData(rows, column, ascending);
      var visibleRows = paginated ? sortedRows.slice(start, end) : sortedRows;
      return (
        /*#__PURE__*/
        React.createElement("div", null,
        /*#__PURE__*/
        React.createElement(SortableTable, _extends({}, props, {
          columns: cols,
          rows: visibleRows
        }, expandableProps, selectableProps)), paginated && [
        /*#__PURE__*/
        React.createElement("hr", {
          key: "separator"
        }),
        /*#__PURE__*/
        React.createElement(Paginator, {
          key: "paginator",
          currentPage: page + 1,
          onClick: function onClick(pg) {
            return _this2.setPage(pg - 1);
          },
          perPage: pageSize,
          totalItems: rows.length
        })])
      );
    }
  }, {
    key: "someSelected",
    get: function get() {
      return this.state.selected.length > 0;
    }
  }, {
    key: "allSelected",
    get: function get() {
      return this.props.rows.length && this.state.selected.length === this.props.rows.length;
    }
  }]);

  return UncontrolledTable;
}(React.Component);

UncontrolledTable.propTypes = _objectSpread(_objectSpread({}, SortableTable.propTypes), {}, {
  expanded: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onExpand: PropTypes.func,
  onPageChange: PropTypes.func,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  selected: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  sort: PropTypes.shape({
    column: PropTypes.string,
    ascending: PropTypes.bool
  }),
  onSelect: PropTypes.func,
  onSort: PropTypes.func
});
UncontrolledTable.defaultProps = _objectSpread(_objectSpread({}, SortableTable.defaultProps), {}, {
  onExpand: function onExpand() {},
  expanded: [],
  onPageChange: function onPageChange() {},
  page: 0,
  pageSize: 10,
  selected: [],
  sort: {
    ascending: true
  },
  onSelect: function onSelect() {},
  onSort: function onSort() {}
});
UncontrolledTable.displayName = "UncontrolledTable";
export { UncontrolledTable as default };